import { startCase } from 'lodash';

import { Advance, Disbursement, Draw } from '@willow/graphql-iso/src/app';
import { AdvanceConfig as GqlAdvanceConfig } from '@willow/graphql-iso/src/app/backend';
import { AdvanceConfig } from '@willow/types-iso';

import { formatDate } from '../utils/dates/dates';
import { formatCurrency } from '../utils/formatCurrency';
import { getAdvanceCategoryLabel } from './getAdvanceCategoryLabel';

const toSentenceCase = (label: string): string =>
  label.length === 0 ? label : `${label.charAt(0)}${label.slice(1).toLowerCase()}`;

export const getAdvanceDescription = (advanceConfig: AdvanceConfig | GqlAdvanceConfig | null | undefined): string => {
  const advanceTypeLabel = startCase((advanceConfig?.advanceType ?? '').toLowerCase());
  const categoryLabel = getAdvanceCategoryLabel(advanceConfig);
  const base = `${advanceTypeLabel} Advance`.trim();
  return categoryLabel ? `${base}, ${toSentenceCase(categoryLabel)}` : base;
};

export const getDisbursementLabel = (item: Disbursement | Draw | Advance): string => {
  switch (item.__typename) {
    case 'Disbursement':
      return `${formatCurrency(item.total)} (${formatDate(item.date)} | Disbursement to ${item.recipient})`;
    case 'Draw':
      return `${formatCurrency(item.amount)} (${formatDate(item.date)} | Draw)`;
    case 'Advance':
      return `${formatCurrency(item.amountRemaining)} (${formatDate(item.chargeDate)} | ${getAdvanceDescription(
        item.advanceConfig,
      )})`;
  }
};
